import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

// Open dashboard links in the existing ticket-detail modal, using a scoped API.
export default function useLinkedTicket(setTicket, setError) {
  const [params, setParams] = useSearchParams();
  const ticketId = params.get("ticket");
  useEffect(() => {
    if (!ticketId) return;
    if (!/^\d+$/.test(ticketId)) {
      setError("Invalid ticket link.");
      return;
    }
    const controller = new AbortController();
    axiosInstance.get(`/api/dashboard/tickets/${ticketId}/`, { signal: controller.signal })
      .then((response) => { if (!controller.signal.aborted) setTicket(response.data); })
      .catch(() => { if (!controller.signal.aborted) setError("This ticket is unavailable or outside your access."); });
    return () => controller.abort();
  }, [ticketId, setTicket, setError]);
  return () => {
    setTicket(null);
    setParams((current) => { const next = new URLSearchParams(current); next.delete("ticket"); return next; }, { replace: true });
  };
}
